<template>
    <v-card>
        <v-flex style="overflow: auto">
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :footer-props="{
          'items-per-page-options': [5, 10, 20]
        }"
                item-key="id"
                :options.sync="options"
                :loading="loading"
                loading-text="Loading recommendations"
                :page="recommendationTableOptions && recommendationTableOptions.page ? recommendationTableOptions.page : 1"
                :server-items-length="itemsCount"
                class="elevation-1 data-analysis-table"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="`da_row_${item.id}`"
                    >
                        <td class="text-center">{{ item.id ? item.id : '-' }}</td>
                        <td class="text-center">{{ item.created_at ? item.created_at : '-' }}</td>
                        <td class="text-center">
                            {{ item.count ? item.count : '-' }}
                        </td>
                        <td class="text-center">
                            <v-chip
                                :color="item.status === 'finished' ? 'success' : item.status === 'error' ? 'error' : 'grey lighten-2'">
                                {{ item.status | cleanString }}
                            </v-chip>
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.status === 'finished'" @click="handleDownloadCsvFile(item.id)">
                                mdi-download
                            </v-icon>
                            <v-icon v-else @click="handleRefresh()">
                                mdi-refresh
                            </v-icon>
                        </td>
                    </tr>

                </template>
            </v-data-table>
        </v-flex>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'DataAnalyticsRecommendationListCard',
    data() {
        return {
            options: {},

            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Created at',
                    align: 'center',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: 'Recommendations count',
                    align: 'center',
                    sortable: false,
                    value: 'count',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Download',
                    align: 'center',
                    sortable: false,
                    value: 'download',
                },
            ],
        };
    },
    computed: {
        ...mapState('analytics', ['loading', 'recommendationTableOptions', 'recommendations', 'recommendationsCount']),
        items() {
            return this.recommendations || [];
        },
        itemsCount() {
            return this.recommendationsCount || 0;
        },
    },
    watch: {
        options(val) {
            this.setRecommendationTableOptions(val);
        },
    },
    methods: {
        ...mapActions('analytics', ['downloadCsvFile', 'getAnalyticsRecommendationDataTableData']),
        ...mapMutations('analytics', ['setRecommendationTableOptions']),
        async handleDownloadCsvFile(rowId) {
            const response = await this.downloadCsvFile(rowId);
            if (!response) {
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${rowId}.csv`);
            document.body.appendChild(link);
            link.click();
        },
        async handleRefresh() {
            await this.getAnalyticsRecommendationDataTableData();
        },
    },
};
</script>

<style scoped>

</style>